import Config from "./Config"
import flex from '@cybersource/flex-sdk-web'
import {jwtDecode} from "jwt-decode";

export type CyberSourceKey = {
  kid: string
  keystore: any
}

export type CyberSourcePaymentMethod = {
  cardNumber: string
  securityCode: string
  cardType: string
  expiryMonth: string
  expiryYear: string
}

export type CyberSourceTokenizedPaymentMethod = {
  keyId: string
  token: any
  maskedPan: string
  cardType: string
  timestamp: number
  signedFields: string
  signature: string
}

export class CyberSourceClient {
  tokenizePaymentMethod = async (key: CyberSourceKey, data: CyberSourcePaymentMethod): Promise<CyberSourceTokenizedPaymentMethod> => {
    const options = {
      ...key,
      cardInfo: data,
      encryptionType: 'rsaoaep256',
      production: !Config.CYBERSOURCE_TEST_MODE,
    };

    return new Promise<CyberSourceTokenizedPaymentMethod>((resolve, reject) => {
      flex.createToken(options, (response: any) => {
        if (response.error) {
          reject(response.error)
        } else {
          resolve(response)
        }
      })
    })
  }
}

export const loadMicroform = ({authentication}: any, customStyles: any): Promise<any> => {
  const decoded: any = jwtDecode(authentication);
  const clientData = decoded.ctx[0].data;

  return new Promise<any>((resolve, reject) => {
    // create script tag
    const script = document.createElement("script");
    script.src = clientData.clientLibrary;
    script.type = "text/javascript";
    script.async = true;
    script.integrity = clientData.clientLibraryIntegrity;
    script.crossOrigin = "anonymous";
    document.head.appendChild(script);
    script.onload = function () {
      let flex = new Flex(authentication);
      const microform = flex.microform("card", {styles: customStyles});
      console.log("LOADED MF ", microform)
      resolve(microform)
    };
  })
}
